/**
 * 📥 Optionen fürs Erfassen, die zum Konto-Profil gehören.
 *
 * Absender mit speichern: Die Etikett-Erkennung liest den Absender ohnehin mit (für den
 * Retouren-Hinweis). Mit dieser Option wird er am Paket gespeichert und lässt sich in der
 * Paketliste einblenden. Standard: aus — dann bleibt alles wie bisher.
 */
const SENDER_KEY = 'kiosk_capture_sender';

export function isCaptureSenderOn() {
  try { return localStorage.getItem(SENDER_KEY) === '1'; } catch { return false; }
}
export function setCaptureSenderOn(on) {
  try { localStorage.setItem(SENDER_KEY, on ? '1' : '0'); } catch { /* */ }
}

/**
 * 🚚 Paketdienst in der Paketliste anzeigen (Wunsch Folkert 21.10.2026). Standard: aus.
 * Gehört zum Konto-Profil (kiosk_list_carrier), wird im Setup unter „Erfassen" eingestellt.
 */
const LIST_CARRIER_KEY = 'kiosk_list_carrier';
export function isListCarrierOn() {
  try { return localStorage.getItem(LIST_CARRIER_KEY) === '1'; } catch { return false; }
}

/**
 * 🏪 Eigener Shop-Name / gesperrte Empfänger-Begriffe (Wunsch Top Phone Solution, 26.10.2026).
 * Kommagetrennte Wörter, die auf Abholpunkt-/Shop2Shop-Etiketten niemals als Kundenname übernommen werden.
 */
const IGNORE_RECIPIENT_KEY = 'kiosk_ignore_recipient';
export function getIgnoreRecipient() {
  try { return (localStorage.getItem(IGNORE_RECIPIENT_KEY) || '').trim(); } catch { return ''; }
}
export function setIgnoreRecipient(val) {
  try {
    const clean = String(val || '').replace(/[^\x20-\x7e\u00a0-\u024f]/g, '').slice(0, 200).trim();
    if (clean) localStorage.setItem(IGNORE_RECIPIENT_KEY, clean);
    else localStorage.removeItem(IGNORE_RECIPIENT_KEY);
  } catch { /* */ }
}
